import { atom } from "recoil";

interface EmailLinksAtomValue {
  links: {
    link: string;
    valid: boolean;
    previewImageId: string | null;
  }[];
  tooManyLinks: boolean;
}

export const EmailLinksAtom = atom<EmailLinksAtomValue>({
  key: "EmailLinksAtom",
  default: { links: [], tooManyLinks: false },
});
